import React from "react";
import { useTranslation } from "react-i18next";
import { formatCurrency } from "../../utils/formatCurrency";

const CampaignBudgetBox = ({ campaign }) => {
  const { t, i18n } = useTranslation();
  return (
    <div className="campaignCard__budget">
      <span className="campaignCard__budget-label">{t("Budget")}</span>
      <span className="campaignCard__budget-value">
        {formatCurrency(campaign.total_price_with_profit, campaign.currency, i18n.language)}
      </span>
    </div>
  );
};

export default CampaignBudgetBox;
